import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ICommonList } from '../common.data-provider';
import { Company } from '../../../models/company.model';
import { Manager, ManagerInfoToCreate } from '../../../models/manager.model';
import { LoaderService } from '../../loader.service';
import { User } from '../../../models/user.model';

export const DI_COMPANIES_PROVIDER = new InjectionToken<ICompaniesProvider>(
  'Provider which implementing ICompaniesProvider interface'
);

export interface ICompaniesProvider {
  loaderService: LoaderService;

  getCompanies(): Observable<ICommonList<Company>>;

  getCompaniesListSubscription(): Observable<ICommonList<Company>>;

  getCompany(id: any): Observable<Company>;

  updateCompany(id: number, body: Partial<Company>): Observable<Company>;

  updateManagerPassword(companyId: number, managerId: number, password: string): Observable<void>;

  createCompany(body: Partial<Company>): Observable<Company>;

  hideCompany(id: number): Observable<any>;

  activateCompany(id: number): Observable<any>;

  removeCompany(id: number): Observable<any>;

  getCompanyManagers(id: number): Observable<ICommonList<Manager>>;

  dismissManager(companyId: any, managerId: any): Observable<any>;

  dismissInvite(companyId: any, inviteId: any): Observable<any>;

  inviteManager(companyId: any, email: any): Observable<any>;

  createManager(companyId: number, manager: ManagerInfoToCreate): Observable<Manager>;

  findManager(companyId: number, email: string, restaurantId?: number): Observable<User>;
}
